import {
  useRef,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Stack
} from '@chakra-ui/react'
import { StyledButtonContainer } from 'common/Buttons/SingleButton/styled'
import dayjs from 'dayjs'
import {
  setPosts,
  setBlogParent,
  setOnPostEditor,
  setPostsTypeStatus
} from 'store'
import {
  BLOGS,
  EDIT_PROFILE,
  ZOOM_LEVEL
} from 'utils/constants'
import { statusMarkerColor } from 'utils/helpers'
import { Affinities } from 'components/UserSection/SingleProfile/Affinities'
import { CodeWords } from 'components/UserSection/SingleProfile/CodeWords'
import { Connections } from 'components/UserSection/SingleProfile/Connections'
import { ShareProfile } from 'components/UserSection/SingleProfile/ShareProfile'
import { SocialLinks } from 'components/UserSection/SingleProfile/SocialLinks'
import { UserInformation } from 'components/UserSection/SingleProfile/UserInformation'
import { WalletAddress } from 'components/UserSection/SingleProfile/WalletAddress'

export const SingleProfile = ({
  setUserSectionPage,
  selectedUser,
  handleSelectLocation
}) => {
  const stackRef = useRef(null)
  const dispatch = useDispatch()
  const [copyText, setCopyText] = useState('Location')
  const {
    full_name,
    affinities,
    social_links,
    profile_picture,
    banner,
    code_words,
    last_accessed,
    coordinates,
    personal_quote,
    past_connections,
    active_connections,
    connections_visibility,
    id,
    wallet_address
  } = selectedUser
  const validDate = dayjs(last_accessed)
  const statusColor = statusMarkerColor(validDate)

  const handleLocation = () => {
    setCopyText('Saved to Clipboard')
    handleSelectLocation(selectedUser)
    setTimeout(() => setCopyText('Location'), 1000)
    navigator.clipboard.writeText(
      process.env.REACT_APP_FRONTEND_URL
      + '?lat=' + coordinates[0]
      + '&lng=' + coordinates[1]
      + '&zoom=' + ZOOM_LEVEL
    )
  }

  return (
    <Stack
      ref={stackRef}
      direction="column"
      spacing="16px"
      padding="24px 65px"
      position="relative"
    >
      <UserInformation
        profilePicture={profile_picture}
        fullName={full_name}
        lastAccessed={last_accessed}
        setUserSectionPage={setUserSectionPage}
        quote={personal_quote}
        coverPicture={banner}
      />
      <Connections
        activeConnections={active_connections}
        pastConnections={past_connections}
        isShowConnections={connections_visibility}
        statusColor={statusColor}
      />
      <CodeWords codeWords={code_words} />
      <Affinities affinities={affinities} />
      <SocialLinks socialLinks={social_links} />

      <Stack
        width="100%"
        marginTop="30px"
        spacing="16px"
      >
        <ShareProfile id={id} />
        <WalletAddress
          id={id}
          walletAddress={wallet_address}
        />
        <StyledButtonContainer
          name="open-profile-blog"
          onClick={() => {
            dispatch(setPosts([]))
            dispatch(setBlogParent([]))
            dispatch(setOnPostEditor(''))
            dispatch(setPostsTypeStatus('posted'))
            dispatch(setUserSectionPage(BLOGS))
          }}
        >
          Blogs
        </StyledButtonContainer>
        <StyledButtonContainer
          onClick={() => handleLocation()}
          name="profile-location"
        >
          {copyText}
        </StyledButtonContainer>
        <StyledButtonContainer
          name="edit-profile"
          onClick={() => dispatch(setUserSectionPage(EDIT_PROFILE))}
        >
          Edit
        </StyledButtonContainer>
      </Stack>

      <Box
        id="bottomBox"
        position="absolute"
        bottom="0"
      />
    </Stack>
  )
}
